import React from "react";

const BuyPage = () => {
  return <div>BuyPage</div>;
};

export default BuyPage;
